/** CPRE Rutland & Lincolnshire — main contact phone */
export const PHONE_NUMBER = '07710 328469';

/** `tel:` URI for click-to-call links (spaces stripped) */
export const PHONE_TEL_HREF = `tel:${PHONE_NUMBER.replace(/\s/g, '')}`;
